import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import moment from 'moment';
import { DeliveryDefenseService } from 'app/delivery-defense/services/delivery-defense.service';
@Component({
  selector: 'upsc-cancel-subscription-popup',
  templateUrl: './cancel-subscription-popup.component.html',
  styleUrls: ['./cancel-subscription-popup.component.scss']
})
export class CancelSubscriptionPopupComponent implements OnInit {
  descriptionData: string;
  ReasonsFormGroup: UntypedFormGroup;
  private reference = [];
  public confirmationPanel = false;
  public isSubmitted = false;
  public suggestionPanel = false;
  currentDate: string;
  formattedDate: any;
  public reasons: string[] = ['Scores not correct', 'Customer service issues', 'Other'];
  constructor(private router: Router, public dialogRef: MatDialogRef<CancelSubscriptionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: UntypedFormBuilder, private deliveryDefenseService: DeliveryDefenseService) {
    dayjs.extend(advancedFormat);
    //this.currentDate = moment().format('MMMM DD, YYYY');
  }


  ngOnInit(): void {
    this.initForm();
  }
  initForm() {
    this.ReasonsFormGroup = this.formBuilder.group({
      reason: [this.reference, Validators.required],
      description: []
    });
  }

  keepSubscription(event) {
    event.preventDefault();
    this.dialogRef.close();
    this.confirmationPanel = false;
  }
  cancelSubscription(event) {
    event.preventDefault();
    this.confirmationPanel = true;
  }

  submitbtn(event) {
    this.confirmationPanel = false;
    this.isSubmitted = true;
    const payload: { Reason: []; Comments: []; } = {
      Reason: this.ReasonsFormGroup?.get('reason').value,
      Comments: this.ReasonsFormGroup?.get('description').value
    };
    this.deliveryDefenseService.deleteSubscription(payload)
      .subscribe(
        result => this.deliveryDefenseService.getSubscriberDetails().subscribe(
          result => {
            this.handleDate(result);
          }
        ),
        err => console.log(err),
      );
  }
  handleDate(result) {
    this.currentDate = result?.CurrentSubEndDate || new Date();
    this.formattedDate = moment(this.currentDate).format('MMMM DD, YYYY');

    if (this.currentDate && dayjs(this.currentDate).isValid()) {
      const endOfMonth = dayjs(this.currentDate).endOf('month');
      const ordinal = (dayjs(endOfMonth).format('Do')).replace(/[0-9]/g, '');
      this.formattedDate = `${ dayjs(endOfMonth).format('MMMM D') }<sup>${ ordinal }</sup>, ${ dayjs(endOfMonth).format('YYYY') }`;
    }
  }
  restartbtn(event) {
    this.closeDialogOnCancel(event);
    this.router.navigate['/delivery-defense-sign-up'];
    this.isSubmitted = false;
  }

  public closeDialogOnCancel(event) {
    event.preventDefault();
    this.dialogRef.close( { isCancelled: true } );
  }

}

